import { render, staticRenderFns } from "./EditTargetSection.vue?vue&type=template&id=3c494c82"
import script from "./EditTargetSection.vue?vue&type=script&lang=js"
export * from "./EditTargetSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports